import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/homework/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/homework/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.homework.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveHomeworkAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_HOMEWORK_ASYNC, vo });

            EditService.saveHomework(
                vo,
                response => {
                    dispatch(Actions.saveHomeworkSuccess(response));
                },
                error => {
                    dispatch(Actions.saveHomeworkFailure(error));
                }
            );
        };
    },

    saveHomeworkSuccess: data => ({
        type: ActionTypes.SAVE_HOMEWORK_SUCCESS,
        parentType: ActionTypes.SAVE_HOMEWORK_ASYNC,
        data
    }),

    saveHomeworkFailure: error => ({
        type: ActionTypes.SAVE_HOMEWORK_FAILURE,
        parentType: ActionTypes.SAVE_HOMEWORK_ASYNC,
        error
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    homework: {}
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, homework: data.homework };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_HOMEWORK_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_HOMEWORK_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_HOMEWORK_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
